import { render, staticRenderFns } from "./SnomedCodingInput.vue?vue&type=template&id=542e9c2a&scoped=true&lang=pug"
import script from "./SnomedCodingInput.vue?vue&type=script&lang=js"
export * from "./SnomedCodingInput.vue?vue&type=script&lang=js"
import style0 from "./SnomedCodingInput.vue?vue&type=style&index=0&id=542e9c2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542e9c2a",
  null
  
)

export default component.exports